import { ReduceStore } from "flux/utils";
import PropTypes from "prop-types";
import Dispatcher from "Dispatcher";
import typeCheckingStore from "data/util/typeCheckingStore";
import loadObjectOf from "data/util/loadObjectOf";
import LoadObject from "data/LoadObject";
import { hotLoadObject } from "data/storeUtils";
import GxepActions from "data/GxepActions";
import DataManager from "data/DataManager";
import userStore from "data/userStore";

class GxepStore extends ReduceStore {
    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return LoadObject.empty();
    }

    reduce(state, action) {
        switch (action.type) {

            case GxepActions.START_LOAD: {
                return state.loading(
                    DataManager.loadGxepInfo(
                        userStore.getActiveOrgKey()));
            }

            case GxepActions.LOADED: {
                return state.done()
                    .clearError()
                    .setValue(action.data);
            }

            case GxepActions.LOAD_ERROR: {
                return LoadObject.withError(action.error);
            }

            case GxepActions.UPDATE_PASSWORD: {
                return state.map(ps =>
                    ps.map(it =>
                        it.key === action.key
                            ? { ...it, password: action.password }
                            : it));
            }

            case GxepActions.START_SAVE: {
                return state.updating(
                    DataManager.saveGxepInfo(
                        userStore.getActiveOrgKey(),
                        state.getValueEnforcing(),
                    ));
            }

            case GxepActions.SAVED:
            case GxepActions.SAVE_ERROR:
            case GxepActions.DIALOG_CLOSED: {
                return this.getInitialState();
            }

            default:
                return state;
        }
    }

    getState() {
        return hotLoadObject(
            () => super.getState(),
            () => Dispatcher.dispatch({
                type: GxepActions.START_LOAD,
            }),
        );
    }
}

export const itemShapeType = PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
});

GxepStore.stateTypes = loadObjectOf(
    PropTypes.arrayOf(itemShapeType)
);

export default typeCheckingStore(new GxepStore());



// WEBPACK FOOTER //
// ./app/data/GxepStore.js